<template>
  <div>
    <div>
      <data-table
       :columns="employeeColumnNames"
       :tableData="employeeDataForOffCycle"
       :withForm="false"
       :showhistory="false"
       :showedit="false"
       :showdelete="false"
        />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex';

  export default {
    data (){
      return {
        employeeColumnNames: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "E-Code",
          key: "empCode"
        },
      ],
      employeeDataForOffCycle: [],
      }
    },

    // mounted(){
    //   if(this.le_id == this.selectedEmployeesList[0].le_id){
    //     this.employeeData = this.selectedEmployeesList[0].employees
    //   }
    // },

    activated(){
      if(this.le_id == this.selectedEmployeesList[0].le_id){
        this.employeeDataForOffCycle = this.selectedEmployeesList[0].employees
      }
    },

    computed: {

      ...mapGetters({
        getleid: "onboard/legal_entities/legal_entity_ID"
      }),

      le_id() {
        if (this.$route.params.entity_index)
          return this.getleid(this.$route.params.entity_index);
        else return this.getleid(0);
      },

      orgId() {
        return this.$store.getters["onboard/getOrgId"];
      },

      ...mapState({
        selectedEmployeesList: state => state.payroll.selectedemployee.employeeDataForOffCycle,
      }),

    }
  }
</script>